import { render, staticRenderFns } from "./polaris_base.vue?vue&type=template&id=79649e50&scoped=true&"
import script from "./polaris_base.vue?vue&type=script&lang=js&"
export * from "./polaris_base.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79649e50",
  null
  
)

export default component.exports